export default function Support() {
  return (
    <div className="max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-6">Assistenza</h2>
      
      <div className="bg-gray-50 rounded-lg p-6">
        <h3 className="text-lg font-semibold mb-4">Come possiamo aiutarti?</h3>
        
        <div className="space-y-6">
          <div>
            <h4 className="font-medium mb-2">Contatti</h4>
            <p className="text-gray-600">
              Email: supporto@pizzaveg.it<br />
              Tel: +39 02 1234567<br />
              Orari: Lun-Ven 9:00-18:00
            </p>
          </div>

          <div>
            <h4 className="font-medium mb-2">FAQ</h4>
            <ul className="space-y-2 text-gray-600">
              <li>
                <strong>Come posso aggiungere una pizzeria?</strong>
                <p>Registrati come pizzeria e accedi alla sezione "Gestione Pizzerie".</p>
              </li>
              <li>
                <strong>Come modifico il menu?</strong>
                <p>Nella sezione "Gestione Pizzerie" puoi aggiungere o rimuovere pizze dal menu.</p>
              </li>
              <li>
                <strong>Come verifico la mia pizzeria?</strong>
                <p>Contattaci via email per avviare il processo di verifica.</p>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium mb-2">Assistenza tecnica</h4>
            <p className="text-gray-600">
              Per problemi tecnici, invia una email a tech@pizzaveg.it specificando:
            </p>
            <ul className="list-disc list-inside text-gray-600 mt-2">
              <li>Il problema riscontrato</li>
              <li>Quando si verifica</li>
              <li>Il tuo browser e sistema operativo</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}